export function getPermissionsEditUrl(manualBackUrl?: string) {
  const url = new URL(window.location.href)
  url.searchParams.append('refresh_permissions', 'true')
  const backUrl = manualBackUrl ?? url.toString()

  const DEFAULT_BASE =
    'https://auth.tesla.com/en_us/user/revoke/consent?revoke_client_id=9da1edefb96f-4837-a344-a028d8fa7fcb'
  const baseUrl =
    process.env.REACT_APP_TESLA_FLEET_ACCOUNT_BASE_URL ?? DEFAULT_BASE
  const encodedBackUrl = encodeURIComponent(backUrl)
  return `${baseUrl}&back_url=${encodedBackUrl}`
}
